import React ,{useEffect} from 'react';
import AOS from 'aos';
import Banner from '../Components/Pages/Collaboration/Banner';
import Features from '../Components/Pages/Collaboration/Features';
import Place from '../Components/Pages/Collaboration/Place';
import Header from '../Components/Shared/Header/Header';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
import Create from '../Components/Pages/Collaboration/Create';
import Customer from '../Components/Shared/Customers/Customers';
import Join from '../Components/Pages/Collaboration/Join';
import Blogs from '../Components/Shared/BlogsSection/Blogs';
import Innovative from '../Components/Pages/Collaboration/Innovative';
import Organize from '../Components/Pages/Collaboration/Organize';
import Activity from '../Components/Pages/Collaboration/Activity';

function Collaboration(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header />
        <Banner />
        <Features />
        <Join />
        <Create />
        <Activity />
        <Organize />
        <Customer />
     
        <Place />
        <Innovative />
        <Blogs />
        <Start />
        <Footer />
        </>
    )
};
export default Collaboration;